export default "__VITE_ASSET__CDzSSMTN__"